module.exports = __webpack_public_path__ + "static/AtlasGrotesk-Medium-Web-c40814098d7f6659af65ac1c59cb86dd.woff2";